import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FULFILLMENTS_IN_TRANSIT_VIEW_ID, FULFILLMENTS_VIEW_ID } from './view-id-constants';

export const FulfillmentsInTransit = {
  label: <FormattedMessage defaultMessage='In Transit' description='shipping page left nav item for in transit fulfillments' id='Foz6yw' />,

  expandedDescription: (
    <FormattedMessage
      defaultMessage='Fulfillments / In Transit'
      description='shipments page grid header, fulfillments.in-transit'
      id='jdmgxs'
    />
  ),

  id: FULFILLMENTS_IN_TRANSIT_VIEW_ID,
  navigationOverride: '/shipments/fulfillments/in-transit',
  parentId: FULFILLMENTS_VIEW_ID,
};
